import { Injectable } from '@angular/core';
import { ValidationErrors, Validator } from '@angular/forms';

@Injectable()
export class MaterialAddressValidator implements Validator {
  validateFn: () => ValidationErrors | null = (): ValidationErrors | null => null;

  private onValidatorChange: () => void = (): void => {};

  validate(): ValidationErrors | null {
    return this.validateFn();
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  revalidate(): void {
    this.onValidatorChange();
  }
}

